/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TermsImport } from './routes/terms'
import { Route as SuperadminDashboardImport } from './routes/superadmin-dashboard'
import { Route as StaticDashboardImport } from './routes/static-dashboard'
import { Route as PrivacyImport } from './routes/privacy'
import { Route as AffiliatesImport } from './routes/affiliates'
import { Route as AppImport } from './routes/_app'
import { Route as IndexImport } from './routes/index'
import { Route as AppAuthImport } from './routes/_app/_auth'
import { Route as AppFlowIndexImport } from './routes/_app/flow/index'
import { Route as AppCampaignsIndexImport } from './routes/_app/campaigns/index'
import { Route as AppLoginLayoutImport } from './routes/_app/login/_layout'
import { Route as AppCampaignsLayoutImport } from './routes/_app/campaigns/_layout'
import { Route as AppAuthGrowImport } from './routes/_app/_auth/grow'
import { Route as AppLoginLayoutIndexImport } from './routes/_app/login/_layout.index'
import { Route as AppInvitesInviteIdIndexImport } from './routes/_app/invites/$inviteId/index'
import { Route as AppCreatorInvitesInviteIdIndexImport } from './routes/_app/creator-invites/$inviteId/index'
import { Route as AppAuthGrowIndexImport } from './routes/_app/_auth/grow/index'
import { Route as AppAuthOnboardingLayoutImport } from './routes/_app/_auth/onboarding/_layout'
import { Route as AppAuthGrowProfileImport } from './routes/_app/_auth/grow/profile'
import { Route as AppAuthGrowContentProducerImport } from './routes/_app/_auth/grow/content-producer'
import { Route as AppAuthDashboardLayoutImport } from './routes/_app/_auth/dashboard/_layout'
import { Route as AppAuthPartnershipsPartnershipIdIndexImport } from './routes/_app/_auth/partnerships/$partnershipId/index'
import { Route as AppAuthDashboardLayoutIndexImport } from './routes/_app/_auth/dashboard/_layout.index'
import { Route as AppAuthCreatorsCreatorIdIndexImport } from './routes/_app/_auth/creators/$creatorId/index'
import { Route as AppAuthPartnershipsPartnershipIdLayoutImport } from './routes/_app/_auth/partnerships/$partnershipId/_layout'
import { Route as AppAuthOnboardingLayoutUsertypeImport } from './routes/_app/_auth/onboarding/_layout.usertype'
import { Route as AppAuthOnboardingLayoutNameImport } from './routes/_app/_auth/onboarding/_layout.name'
import { Route as AppAuthOnboardingLayoutCreatoronboardingImport } from './routes/_app/_auth/onboarding/_layout.creator_onboarding'
import { Route as AppAuthOnboardingLayoutApponboardingImport } from './routes/_app/_auth/onboarding/_layout.app_onboarding'
import { Route as AppAuthDashboardLayoutWelcomeImport } from './routes/_app/_auth/dashboard/_layout.welcome'
import { Route as AppAuthDashboardLayoutVideosoverviewImport } from './routes/_app/_auth/dashboard/_layout.videosoverview'
import { Route as AppAuthDashboardLayoutSettingsImport } from './routes/_app/_auth/dashboard/_layout.settings'
import { Route as AppAuthDashboardLayoutPayoutsImport } from './routes/_app/_auth/dashboard/_layout.payouts'
import { Route as AppAuthDashboardLayoutMetaImport } from './routes/_app/_auth/dashboard/_layout.meta'
import { Route as AppAuthDashboardLayoutLeaderboardImport } from './routes/_app/_auth/dashboard/_layout.leaderboard'
import { Route as AppAuthDashboardLayoutGetInspiredImport } from './routes/_app/_auth/dashboard/_layout.getInspired'
import { Route as AppAuthDashboardLayoutCustomLeaderboardImport } from './routes/_app/_auth/dashboard/_layout.customLeaderboard'
import { Route as AppAuthDashboardLayoutCompetitorsImport } from './routes/_app/_auth/dashboard/_layout.competitors'
import { Route as AppAuthDashboardLayoutCommunityImport } from './routes/_app/_auth/dashboard/_layout.community'
import { Route as AppAuthCreatorsCreatorIdLayoutImport } from './routes/_app/_auth/creators/$creatorId/_layout'
import { Route as AppAuthDashboardLayoutSettingsIndexImport } from './routes/_app/_auth/dashboard/_layout.settings.index'
import { Route as AppAuthDashboardLayoutPartnershipsIndexImport } from './routes/_app/_auth/dashboard/_layout.partnerships.index'
import { Route as AppAuthDashboardLayoutSettingsTeamImport } from './routes/_app/_auth/dashboard/_layout.settings.team'
import { Route as AppAuthDashboardLayoutSettingsInvitesImport } from './routes/_app/_auth/dashboard/_layout.settings.invites'
import { Route as AppAuthDashboardLayoutSettingsCreatorInvitesImport } from './routes/_app/_auth/dashboard/_layout.settings.creator-invites'
import { Route as AppAuthDashboardLayoutSettingsBillingImport } from './routes/_app/_auth/dashboard/_layout.settings.billing'
import { Route as AppAuthDashboardLayoutSettingsAffiliatesImport } from './routes/_app/_auth/dashboard/_layout.settings.affiliates'
import { Route as AppAuthDashboardLayoutPartnershipsApplyImport } from './routes/_app/_auth/dashboard/_layout.partnerships.apply'

// Create Virtual Routes

const AppLoginImport = createFileRoute('/_app/login')()
const AppCampaignsImport = createFileRoute('/_app/campaigns')()
const AppAuthOnboardingImport = createFileRoute('/_app/_auth/onboarding')()
const AppAuthDashboardImport = createFileRoute('/_app/_auth/dashboard')()
const AppAuthPartnershipsPartnershipIdImport = createFileRoute(
  '/_app/_auth/partnerships/$partnershipId',
)()
const AppAuthCreatorsCreatorIdImport = createFileRoute(
  '/_app/_auth/creators/$creatorId',
)()

// Create/Update Routes

const TermsRoute = TermsImport.update({
  path: '/terms',
  getParentRoute: () => rootRoute,
} as any)

const SuperadminDashboardRoute = SuperadminDashboardImport.update({
  path: '/superadmin-dashboard',
  getParentRoute: () => rootRoute,
} as any)

const StaticDashboardRoute = StaticDashboardImport.update({
  path: '/static-dashboard',
  getParentRoute: () => rootRoute,
} as any)

const PrivacyRoute = PrivacyImport.update({
  path: '/privacy',
  getParentRoute: () => rootRoute,
} as any)

const AffiliatesRoute = AffiliatesImport.update({
  path: '/affiliates',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AppLoginRoute = AppLoginImport.update({
  path: '/login',
  getParentRoute: () => AppRoute,
} as any)

const AppCampaignsRoute = AppCampaignsImport.update({
  path: '/campaigns',
  getParentRoute: () => AppRoute,
} as any)

const AppAuthRoute = AppAuthImport.update({
  id: '/_auth',
  getParentRoute: () => AppRoute,
} as any)

const AppAuthOnboardingRoute = AppAuthOnboardingImport.update({
  path: '/onboarding',
  getParentRoute: () => AppAuthRoute,
} as any)

const AppAuthDashboardRoute = AppAuthDashboardImport.update({
  path: '/dashboard',
  getParentRoute: () => AppAuthRoute,
} as any)

const AppFlowIndexRoute = AppFlowIndexImport.update({
  path: '/flow/',
  getParentRoute: () => AppRoute,
} as any)

const AppCampaignsIndexRoute = AppCampaignsIndexImport.update({
  path: '/',
  getParentRoute: () => AppCampaignsRoute,
} as any)

const AppLoginLayoutRoute = AppLoginLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AppLoginRoute,
} as any)

const AppCampaignsLayoutRoute = AppCampaignsLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AppCampaignsRoute,
} as any)

const AppAuthGrowRoute = AppAuthGrowImport.update({
  path: '/grow',
  getParentRoute: () => AppAuthRoute,
} as any)

const AppAuthPartnershipsPartnershipIdRoute =
  AppAuthPartnershipsPartnershipIdImport.update({
    path: '/partnerships/$partnershipId',
    getParentRoute: () => AppAuthRoute,
  } as any)

const AppAuthCreatorsCreatorIdRoute = AppAuthCreatorsCreatorIdImport.update({
  path: '/creators/$creatorId',
  getParentRoute: () => AppAuthRoute,
} as any)

const AppLoginLayoutIndexRoute = AppLoginLayoutIndexImport.update({
  path: '/',
  getParentRoute: () => AppLoginLayoutRoute,
} as any)

const AppInvitesInviteIdIndexRoute = AppInvitesInviteIdIndexImport.update({
  path: '/invites/$inviteId/',
  getParentRoute: () => AppRoute,
} as any)

const AppCreatorInvitesInviteIdIndexRoute =
  AppCreatorInvitesInviteIdIndexImport.update({
    path: '/creator-invites/$inviteId/',
    getParentRoute: () => AppRoute,
  } as any)

const AppAuthGrowIndexRoute = AppAuthGrowIndexImport.update({
  path: '/',
  getParentRoute: () => AppAuthGrowRoute,
} as any)

const AppAuthOnboardingLayoutRoute = AppAuthOnboardingLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AppAuthOnboardingRoute,
} as any)

const AppAuthGrowProfileRoute = AppAuthGrowProfileImport.update({
  path: '/profile',
  getParentRoute: () => AppAuthGrowRoute,
} as any)

const AppAuthGrowContentProducerRoute = AppAuthGrowContentProducerImport.update(
  {
    path: '/content-producer',
    getParentRoute: () => AppAuthGrowRoute,
  } as any,
)

const AppAuthDashboardLayoutRoute = AppAuthDashboardLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AppAuthDashboardRoute,
} as any)

const AppAuthPartnershipsPartnershipIdIndexRoute =
  AppAuthPartnershipsPartnershipIdIndexImport.update({
    path: '/',
    getParentRoute: () => AppAuthPartnershipsPartnershipIdRoute,
  } as any)

const AppAuthDashboardLayoutIndexRoute =
  AppAuthDashboardLayoutIndexImport.update({
    path: '/',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthCreatorsCreatorIdIndexRoute =
  AppAuthCreatorsCreatorIdIndexImport.update({
    path: '/',
    getParentRoute: () => AppAuthCreatorsCreatorIdRoute,
  } as any)

const AppAuthPartnershipsPartnershipIdLayoutRoute =
  AppAuthPartnershipsPartnershipIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AppAuthPartnershipsPartnershipIdRoute,
  } as any)

const AppAuthOnboardingLayoutUsertypeRoute =
  AppAuthOnboardingLayoutUsertypeImport.update({
    path: '/usertype',
    getParentRoute: () => AppAuthOnboardingLayoutRoute,
  } as any)

const AppAuthOnboardingLayoutNameRoute =
  AppAuthOnboardingLayoutNameImport.update({
    path: '/name',
    getParentRoute: () => AppAuthOnboardingLayoutRoute,
  } as any)

const AppAuthOnboardingLayoutCreatoronboardingRoute =
  AppAuthOnboardingLayoutCreatoronboardingImport.update({
    path: '/creator_onboarding',
    getParentRoute: () => AppAuthOnboardingLayoutRoute,
  } as any)

const AppAuthOnboardingLayoutApponboardingRoute =
  AppAuthOnboardingLayoutApponboardingImport.update({
    path: '/app_onboarding',
    getParentRoute: () => AppAuthOnboardingLayoutRoute,
  } as any)

const AppAuthDashboardLayoutWelcomeRoute =
  AppAuthDashboardLayoutWelcomeImport.update({
    path: '/welcome',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutVideosoverviewRoute =
  AppAuthDashboardLayoutVideosoverviewImport.update({
    path: '/videosoverview',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutSettingsRoute =
  AppAuthDashboardLayoutSettingsImport.update({
    path: '/settings',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutPayoutsRoute =
  AppAuthDashboardLayoutPayoutsImport.update({
    path: '/payouts',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutMetaRoute = AppAuthDashboardLayoutMetaImport.update(
  {
    path: '/meta',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any,
)

const AppAuthDashboardLayoutLeaderboardRoute =
  AppAuthDashboardLayoutLeaderboardImport.update({
    path: '/leaderboard',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutGetInspiredRoute =
  AppAuthDashboardLayoutGetInspiredImport.update({
    path: '/getInspired',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutCustomLeaderboardRoute =
  AppAuthDashboardLayoutCustomLeaderboardImport.update({
    path: '/customLeaderboard',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutCompetitorsRoute =
  AppAuthDashboardLayoutCompetitorsImport.update({
    path: '/competitors',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutCommunityRoute =
  AppAuthDashboardLayoutCommunityImport.update({
    path: '/community',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthCreatorsCreatorIdLayoutRoute =
  AppAuthCreatorsCreatorIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AppAuthCreatorsCreatorIdRoute,
  } as any)

const AppAuthDashboardLayoutSettingsIndexRoute =
  AppAuthDashboardLayoutSettingsIndexImport.update({
    path: '/',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutPartnershipsIndexRoute =
  AppAuthDashboardLayoutPartnershipsIndexImport.update({
    path: '/partnerships/',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutSettingsTeamRoute =
  AppAuthDashboardLayoutSettingsTeamImport.update({
    path: '/team',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutSettingsInvitesRoute =
  AppAuthDashboardLayoutSettingsInvitesImport.update({
    path: '/invites',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutSettingsCreatorInvitesRoute =
  AppAuthDashboardLayoutSettingsCreatorInvitesImport.update({
    path: '/creator-invites',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutSettingsBillingRoute =
  AppAuthDashboardLayoutSettingsBillingImport.update({
    path: '/billing',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutSettingsAffiliatesRoute =
  AppAuthDashboardLayoutSettingsAffiliatesImport.update({
    path: '/affiliates',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutPartnershipsApplyRoute =
  AppAuthDashboardLayoutPartnershipsApplyImport.update({
    path: '/partnerships/apply',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/affiliates': {
      id: '/affiliates'
      path: '/affiliates'
      fullPath: '/affiliates'
      preLoaderRoute: typeof AffiliatesImport
      parentRoute: typeof rootRoute
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyImport
      parentRoute: typeof rootRoute
    }
    '/static-dashboard': {
      id: '/static-dashboard'
      path: '/static-dashboard'
      fullPath: '/static-dashboard'
      preLoaderRoute: typeof StaticDashboardImport
      parentRoute: typeof rootRoute
    }
    '/superadmin-dashboard': {
      id: '/superadmin-dashboard'
      path: '/superadmin-dashboard'
      fullPath: '/superadmin-dashboard'
      preLoaderRoute: typeof SuperadminDashboardImport
      parentRoute: typeof rootRoute
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsImport
      parentRoute: typeof rootRoute
    }
    '/_app/_auth': {
      id: '/_app/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppAuthImport
      parentRoute: typeof AppImport
    }
    '/_app/_auth/grow': {
      id: '/_app/_auth/grow'
      path: '/grow'
      fullPath: '/grow'
      preLoaderRoute: typeof AppAuthGrowImport
      parentRoute: typeof AppAuthImport
    }
    '/_app/campaigns': {
      id: '/_app/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof AppCampaignsImport
      parentRoute: typeof AppImport
    }
    '/_app/campaigns/_layout': {
      id: '/_app/campaigns/_layout'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof AppCampaignsLayoutImport
      parentRoute: typeof AppCampaignsRoute
    }
    '/_app/login': {
      id: '/_app/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AppLoginImport
      parentRoute: typeof AppImport
    }
    '/_app/login/_layout': {
      id: '/_app/login/_layout'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AppLoginLayoutImport
      parentRoute: typeof AppLoginRoute
    }
    '/_app/campaigns/': {
      id: '/_app/campaigns/'
      path: '/'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof AppCampaignsIndexImport
      parentRoute: typeof AppCampaignsImport
    }
    '/_app/flow/': {
      id: '/_app/flow/'
      path: '/flow'
      fullPath: '/flow'
      preLoaderRoute: typeof AppFlowIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/_auth/dashboard': {
      id: '/_app/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppAuthDashboardImport
      parentRoute: typeof AppAuthImport
    }
    '/_app/_auth/dashboard/_layout': {
      id: '/_app/_auth/dashboard/_layout'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppAuthDashboardLayoutImport
      parentRoute: typeof AppAuthDashboardRoute
    }
    '/_app/_auth/grow/content-producer': {
      id: '/_app/_auth/grow/content-producer'
      path: '/content-producer'
      fullPath: '/grow/content-producer'
      preLoaderRoute: typeof AppAuthGrowContentProducerImport
      parentRoute: typeof AppAuthGrowImport
    }
    '/_app/_auth/grow/profile': {
      id: '/_app/_auth/grow/profile'
      path: '/profile'
      fullPath: '/grow/profile'
      preLoaderRoute: typeof AppAuthGrowProfileImport
      parentRoute: typeof AppAuthGrowImport
    }
    '/_app/_auth/onboarding': {
      id: '/_app/_auth/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AppAuthOnboardingImport
      parentRoute: typeof AppAuthImport
    }
    '/_app/_auth/onboarding/_layout': {
      id: '/_app/_auth/onboarding/_layout'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AppAuthOnboardingLayoutImport
      parentRoute: typeof AppAuthOnboardingRoute
    }
    '/_app/_auth/grow/': {
      id: '/_app/_auth/grow/'
      path: '/'
      fullPath: '/grow/'
      preLoaderRoute: typeof AppAuthGrowIndexImport
      parentRoute: typeof AppAuthGrowImport
    }
    '/_app/creator-invites/$inviteId/': {
      id: '/_app/creator-invites/$inviteId/'
      path: '/creator-invites/$inviteId'
      fullPath: '/creator-invites/$inviteId'
      preLoaderRoute: typeof AppCreatorInvitesInviteIdIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/invites/$inviteId/': {
      id: '/_app/invites/$inviteId/'
      path: '/invites/$inviteId'
      fullPath: '/invites/$inviteId'
      preLoaderRoute: typeof AppInvitesInviteIdIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/login/_layout/': {
      id: '/_app/login/_layout/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof AppLoginLayoutIndexImport
      parentRoute: typeof AppLoginLayoutImport
    }
    '/_app/_auth/creators/$creatorId': {
      id: '/_app/_auth/creators/$creatorId'
      path: '/creators/$creatorId'
      fullPath: '/creators/$creatorId'
      preLoaderRoute: typeof AppAuthCreatorsCreatorIdImport
      parentRoute: typeof AppAuthImport
    }
    '/_app/_auth/creators/$creatorId/_layout': {
      id: '/_app/_auth/creators/$creatorId/_layout'
      path: '/creators/$creatorId'
      fullPath: '/creators/$creatorId'
      preLoaderRoute: typeof AppAuthCreatorsCreatorIdLayoutImport
      parentRoute: typeof AppAuthCreatorsCreatorIdRoute
    }
    '/_app/_auth/dashboard/_layout/community': {
      id: '/_app/_auth/dashboard/_layout/community'
      path: '/community'
      fullPath: '/dashboard/community'
      preLoaderRoute: typeof AppAuthDashboardLayoutCommunityImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/competitors': {
      id: '/_app/_auth/dashboard/_layout/competitors'
      path: '/competitors'
      fullPath: '/dashboard/competitors'
      preLoaderRoute: typeof AppAuthDashboardLayoutCompetitorsImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/customLeaderboard': {
      id: '/_app/_auth/dashboard/_layout/customLeaderboard'
      path: '/customLeaderboard'
      fullPath: '/dashboard/customLeaderboard'
      preLoaderRoute: typeof AppAuthDashboardLayoutCustomLeaderboardImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/getInspired': {
      id: '/_app/_auth/dashboard/_layout/getInspired'
      path: '/getInspired'
      fullPath: '/dashboard/getInspired'
      preLoaderRoute: typeof AppAuthDashboardLayoutGetInspiredImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/leaderboard': {
      id: '/_app/_auth/dashboard/_layout/leaderboard'
      path: '/leaderboard'
      fullPath: '/dashboard/leaderboard'
      preLoaderRoute: typeof AppAuthDashboardLayoutLeaderboardImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/meta': {
      id: '/_app/_auth/dashboard/_layout/meta'
      path: '/meta'
      fullPath: '/dashboard/meta'
      preLoaderRoute: typeof AppAuthDashboardLayoutMetaImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/payouts': {
      id: '/_app/_auth/dashboard/_layout/payouts'
      path: '/payouts'
      fullPath: '/dashboard/payouts'
      preLoaderRoute: typeof AppAuthDashboardLayoutPayoutsImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/settings': {
      id: '/_app/_auth/dashboard/_layout/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/videosoverview': {
      id: '/_app/_auth/dashboard/_layout/videosoverview'
      path: '/videosoverview'
      fullPath: '/dashboard/videosoverview'
      preLoaderRoute: typeof AppAuthDashboardLayoutVideosoverviewImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/welcome': {
      id: '/_app/_auth/dashboard/_layout/welcome'
      path: '/welcome'
      fullPath: '/dashboard/welcome'
      preLoaderRoute: typeof AppAuthDashboardLayoutWelcomeImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/onboarding/_layout/app_onboarding': {
      id: '/_app/_auth/onboarding/_layout/app_onboarding'
      path: '/app_onboarding'
      fullPath: '/onboarding/app_onboarding'
      preLoaderRoute: typeof AppAuthOnboardingLayoutApponboardingImport
      parentRoute: typeof AppAuthOnboardingLayoutImport
    }
    '/_app/_auth/onboarding/_layout/creator_onboarding': {
      id: '/_app/_auth/onboarding/_layout/creator_onboarding'
      path: '/creator_onboarding'
      fullPath: '/onboarding/creator_onboarding'
      preLoaderRoute: typeof AppAuthOnboardingLayoutCreatoronboardingImport
      parentRoute: typeof AppAuthOnboardingLayoutImport
    }
    '/_app/_auth/onboarding/_layout/name': {
      id: '/_app/_auth/onboarding/_layout/name'
      path: '/name'
      fullPath: '/onboarding/name'
      preLoaderRoute: typeof AppAuthOnboardingLayoutNameImport
      parentRoute: typeof AppAuthOnboardingLayoutImport
    }
    '/_app/_auth/onboarding/_layout/usertype': {
      id: '/_app/_auth/onboarding/_layout/usertype'
      path: '/usertype'
      fullPath: '/onboarding/usertype'
      preLoaderRoute: typeof AppAuthOnboardingLayoutUsertypeImport
      parentRoute: typeof AppAuthOnboardingLayoutImport
    }
    '/_app/_auth/partnerships/$partnershipId': {
      id: '/_app/_auth/partnerships/$partnershipId'
      path: '/partnerships/$partnershipId'
      fullPath: '/partnerships/$partnershipId'
      preLoaderRoute: typeof AppAuthPartnershipsPartnershipIdImport
      parentRoute: typeof AppAuthImport
    }
    '/_app/_auth/partnerships/$partnershipId/_layout': {
      id: '/_app/_auth/partnerships/$partnershipId/_layout'
      path: '/partnerships/$partnershipId'
      fullPath: '/partnerships/$partnershipId'
      preLoaderRoute: typeof AppAuthPartnershipsPartnershipIdLayoutImport
      parentRoute: typeof AppAuthPartnershipsPartnershipIdRoute
    }
    '/_app/_auth/creators/$creatorId/': {
      id: '/_app/_auth/creators/$creatorId/'
      path: '/'
      fullPath: '/creators/$creatorId/'
      preLoaderRoute: typeof AppAuthCreatorsCreatorIdIndexImport
      parentRoute: typeof AppAuthCreatorsCreatorIdImport
    }
    '/_app/_auth/dashboard/_layout/': {
      id: '/_app/_auth/dashboard/_layout/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AppAuthDashboardLayoutIndexImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/partnerships/$partnershipId/': {
      id: '/_app/_auth/partnerships/$partnershipId/'
      path: '/'
      fullPath: '/partnerships/$partnershipId/'
      preLoaderRoute: typeof AppAuthPartnershipsPartnershipIdIndexImport
      parentRoute: typeof AppAuthPartnershipsPartnershipIdImport
    }
    '/_app/_auth/dashboard/_layout/partnerships/apply': {
      id: '/_app/_auth/dashboard/_layout/partnerships/apply'
      path: '/partnerships/apply'
      fullPath: '/dashboard/partnerships/apply'
      preLoaderRoute: typeof AppAuthDashboardLayoutPartnershipsApplyImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/settings/affiliates': {
      id: '/_app/_auth/dashboard/_layout/settings/affiliates'
      path: '/affiliates'
      fullPath: '/dashboard/settings/affiliates'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsAffiliatesImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
    '/_app/_auth/dashboard/_layout/settings/billing': {
      id: '/_app/_auth/dashboard/_layout/settings/billing'
      path: '/billing'
      fullPath: '/dashboard/settings/billing'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsBillingImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
    '/_app/_auth/dashboard/_layout/settings/creator-invites': {
      id: '/_app/_auth/dashboard/_layout/settings/creator-invites'
      path: '/creator-invites'
      fullPath: '/dashboard/settings/creator-invites'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsCreatorInvitesImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
    '/_app/_auth/dashboard/_layout/settings/invites': {
      id: '/_app/_auth/dashboard/_layout/settings/invites'
      path: '/invites'
      fullPath: '/dashboard/settings/invites'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsInvitesImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
    '/_app/_auth/dashboard/_layout/settings/team': {
      id: '/_app/_auth/dashboard/_layout/settings/team'
      path: '/team'
      fullPath: '/dashboard/settings/team'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsTeamImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
    '/_app/_auth/dashboard/_layout/partnerships/': {
      id: '/_app/_auth/dashboard/_layout/partnerships/'
      path: '/partnerships'
      fullPath: '/dashboard/partnerships'
      preLoaderRoute: typeof AppAuthDashboardLayoutPartnershipsIndexImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/settings/': {
      id: '/_app/_auth/dashboard/_layout/settings/'
      path: '/'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsIndexImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  AppRoute: AppRoute.addChildren({
    AppAuthRoute: AppAuthRoute.addChildren({
      AppAuthGrowRoute: AppAuthGrowRoute.addChildren({
        AppAuthGrowContentProducerRoute,
        AppAuthGrowProfileRoute,
        AppAuthGrowIndexRoute,
      }),
      AppAuthDashboardRoute: AppAuthDashboardRoute.addChildren({
        AppAuthDashboardLayoutRoute: AppAuthDashboardLayoutRoute.addChildren({
          AppAuthDashboardLayoutCommunityRoute,
          AppAuthDashboardLayoutCompetitorsRoute,
          AppAuthDashboardLayoutCustomLeaderboardRoute,
          AppAuthDashboardLayoutGetInspiredRoute,
          AppAuthDashboardLayoutLeaderboardRoute,
          AppAuthDashboardLayoutMetaRoute,
          AppAuthDashboardLayoutPayoutsRoute,
          AppAuthDashboardLayoutSettingsRoute:
            AppAuthDashboardLayoutSettingsRoute.addChildren({
              AppAuthDashboardLayoutSettingsAffiliatesRoute,
              AppAuthDashboardLayoutSettingsBillingRoute,
              AppAuthDashboardLayoutSettingsCreatorInvitesRoute,
              AppAuthDashboardLayoutSettingsInvitesRoute,
              AppAuthDashboardLayoutSettingsTeamRoute,
              AppAuthDashboardLayoutSettingsIndexRoute,
            }),
          AppAuthDashboardLayoutVideosoverviewRoute,
          AppAuthDashboardLayoutWelcomeRoute,
          AppAuthDashboardLayoutIndexRoute,
          AppAuthDashboardLayoutPartnershipsApplyRoute,
          AppAuthDashboardLayoutPartnershipsIndexRoute,
        }),
      }),
      AppAuthOnboardingRoute: AppAuthOnboardingRoute.addChildren({
        AppAuthOnboardingLayoutRoute: AppAuthOnboardingLayoutRoute.addChildren({
          AppAuthOnboardingLayoutApponboardingRoute,
          AppAuthOnboardingLayoutCreatoronboardingRoute,
          AppAuthOnboardingLayoutNameRoute,
          AppAuthOnboardingLayoutUsertypeRoute,
        }),
      }),
      AppAuthCreatorsCreatorIdRoute: AppAuthCreatorsCreatorIdRoute.addChildren({
        AppAuthCreatorsCreatorIdIndexRoute,
      }),
      AppAuthPartnershipsPartnershipIdRoute:
        AppAuthPartnershipsPartnershipIdRoute.addChildren({
          AppAuthPartnershipsPartnershipIdIndexRoute,
        }),
    }),
    AppCampaignsRoute: AppCampaignsRoute.addChildren({
      AppCampaignsIndexRoute,
    }),
    AppLoginRoute: AppLoginRoute.addChildren({
      AppLoginLayoutRoute: AppLoginLayoutRoute.addChildren({
        AppLoginLayoutIndexRoute,
      }),
    }),
    AppFlowIndexRoute,
    AppCreatorInvitesInviteIdIndexRoute,
    AppInvitesInviteIdIndexRoute,
  }),
  AffiliatesRoute,
  PrivacyRoute,
  StaticDashboardRoute,
  SuperadminDashboardRoute,
  TermsRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_app",
        "/affiliates",
        "/privacy",
        "/static-dashboard",
        "/superadmin-dashboard",
        "/terms"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/_auth",
        "/_app/campaigns",
        "/_app/login",
        "/_app/flow/",
        "/_app/creator-invites/$inviteId/",
        "/_app/invites/$inviteId/"
      ]
    },
    "/affiliates": {
      "filePath": "affiliates.tsx"
    },
    "/privacy": {
      "filePath": "privacy.tsx"
    },
    "/static-dashboard": {
      "filePath": "static-dashboard.tsx"
    },
    "/superadmin-dashboard": {
      "filePath": "superadmin-dashboard.tsx"
    },
    "/terms": {
      "filePath": "terms.tsx"
    },
    "/_app/_auth": {
      "filePath": "_app/_auth.tsx",
      "parent": "/_app",
      "children": [
        "/_app/_auth/grow",
        "/_app/_auth/dashboard",
        "/_app/_auth/onboarding",
        "/_app/_auth/creators/$creatorId",
        "/_app/_auth/partnerships/$partnershipId"
      ]
    },
    "/_app/_auth/grow": {
      "filePath": "_app/_auth/grow.tsx",
      "parent": "/_app/_auth",
      "children": [
        "/_app/_auth/grow/content-producer",
        "/_app/_auth/grow/profile",
        "/_app/_auth/grow/"
      ]
    },
    "/_app/campaigns": {
      "filePath": "_app/campaigns",
      "parent": "/_app",
      "children": [
        "/_app/campaigns/_layout",
        "/_app/campaigns/"
      ]
    },
    "/_app/campaigns/_layout": {
      "filePath": "_app/campaigns/_layout.tsx",
      "parent": "/_app/campaigns"
    },
    "/_app/login": {
      "filePath": "_app/login",
      "parent": "/_app",
      "children": [
        "/_app/login/_layout"
      ]
    },
    "/_app/login/_layout": {
      "filePath": "_app/login/_layout.tsx",
      "parent": "/_app/login",
      "children": [
        "/_app/login/_layout/"
      ]
    },
    "/_app/campaigns/": {
      "filePath": "_app/campaigns/index.tsx",
      "parent": "/_app/campaigns"
    },
    "/_app/flow/": {
      "filePath": "_app/flow/index.tsx",
      "parent": "/_app"
    },
    "/_app/_auth/dashboard": {
      "filePath": "_app/_auth/dashboard",
      "parent": "/_app/_auth",
      "children": [
        "/_app/_auth/dashboard/_layout"
      ]
    },
    "/_app/_auth/dashboard/_layout": {
      "filePath": "_app/_auth/dashboard/_layout.tsx",
      "parent": "/_app/_auth/dashboard",
      "children": [
        "/_app/_auth/dashboard/_layout/community",
        "/_app/_auth/dashboard/_layout/competitors",
        "/_app/_auth/dashboard/_layout/customLeaderboard",
        "/_app/_auth/dashboard/_layout/getInspired",
        "/_app/_auth/dashboard/_layout/leaderboard",
        "/_app/_auth/dashboard/_layout/meta",
        "/_app/_auth/dashboard/_layout/payouts",
        "/_app/_auth/dashboard/_layout/settings",
        "/_app/_auth/dashboard/_layout/videosoverview",
        "/_app/_auth/dashboard/_layout/welcome",
        "/_app/_auth/dashboard/_layout/",
        "/_app/_auth/dashboard/_layout/partnerships/apply",
        "/_app/_auth/dashboard/_layout/partnerships/"
      ]
    },
    "/_app/_auth/grow/content-producer": {
      "filePath": "_app/_auth/grow/content-producer.tsx",
      "parent": "/_app/_auth/grow"
    },
    "/_app/_auth/grow/profile": {
      "filePath": "_app/_auth/grow/profile.tsx",
      "parent": "/_app/_auth/grow"
    },
    "/_app/_auth/onboarding": {
      "filePath": "_app/_auth/onboarding",
      "parent": "/_app/_auth",
      "children": [
        "/_app/_auth/onboarding/_layout"
      ]
    },
    "/_app/_auth/onboarding/_layout": {
      "filePath": "_app/_auth/onboarding/_layout.tsx",
      "parent": "/_app/_auth/onboarding",
      "children": [
        "/_app/_auth/onboarding/_layout/app_onboarding",
        "/_app/_auth/onboarding/_layout/creator_onboarding",
        "/_app/_auth/onboarding/_layout/name",
        "/_app/_auth/onboarding/_layout/usertype"
      ]
    },
    "/_app/_auth/grow/": {
      "filePath": "_app/_auth/grow/index.tsx",
      "parent": "/_app/_auth/grow"
    },
    "/_app/creator-invites/$inviteId/": {
      "filePath": "_app/creator-invites/$inviteId/index.tsx",
      "parent": "/_app"
    },
    "/_app/invites/$inviteId/": {
      "filePath": "_app/invites/$inviteId/index.tsx",
      "parent": "/_app"
    },
    "/_app/login/_layout/": {
      "filePath": "_app/login/_layout.index.tsx",
      "parent": "/_app/login/_layout"
    },
    "/_app/_auth/creators/$creatorId": {
      "filePath": "_app/_auth/creators/$creatorId",
      "parent": "/_app/_auth",
      "children": [
        "/_app/_auth/creators/$creatorId/_layout",
        "/_app/_auth/creators/$creatorId/"
      ]
    },
    "/_app/_auth/creators/$creatorId/_layout": {
      "filePath": "_app/_auth/creators/$creatorId/_layout.tsx",
      "parent": "/_app/_auth/creators/$creatorId"
    },
    "/_app/_auth/dashboard/_layout/community": {
      "filePath": "_app/_auth/dashboard/_layout.community.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/competitors": {
      "filePath": "_app/_auth/dashboard/_layout.competitors.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/customLeaderboard": {
      "filePath": "_app/_auth/dashboard/_layout.customLeaderboard.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/getInspired": {
      "filePath": "_app/_auth/dashboard/_layout.getInspired.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/leaderboard": {
      "filePath": "_app/_auth/dashboard/_layout.leaderboard.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/meta": {
      "filePath": "_app/_auth/dashboard/_layout.meta.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/payouts": {
      "filePath": "_app/_auth/dashboard/_layout.payouts.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/settings": {
      "filePath": "_app/_auth/dashboard/_layout.settings.tsx",
      "parent": "/_app/_auth/dashboard/_layout",
      "children": [
        "/_app/_auth/dashboard/_layout/settings/affiliates",
        "/_app/_auth/dashboard/_layout/settings/billing",
        "/_app/_auth/dashboard/_layout/settings/creator-invites",
        "/_app/_auth/dashboard/_layout/settings/invites",
        "/_app/_auth/dashboard/_layout/settings/team",
        "/_app/_auth/dashboard/_layout/settings/"
      ]
    },
    "/_app/_auth/dashboard/_layout/videosoverview": {
      "filePath": "_app/_auth/dashboard/_layout.videosoverview.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/welcome": {
      "filePath": "_app/_auth/dashboard/_layout.welcome.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/onboarding/_layout/app_onboarding": {
      "filePath": "_app/_auth/onboarding/_layout.app_onboarding.tsx",
      "parent": "/_app/_auth/onboarding/_layout"
    },
    "/_app/_auth/onboarding/_layout/creator_onboarding": {
      "filePath": "_app/_auth/onboarding/_layout.creator_onboarding.tsx",
      "parent": "/_app/_auth/onboarding/_layout"
    },
    "/_app/_auth/onboarding/_layout/name": {
      "filePath": "_app/_auth/onboarding/_layout.name.tsx",
      "parent": "/_app/_auth/onboarding/_layout"
    },
    "/_app/_auth/onboarding/_layout/usertype": {
      "filePath": "_app/_auth/onboarding/_layout.usertype.tsx",
      "parent": "/_app/_auth/onboarding/_layout"
    },
    "/_app/_auth/partnerships/$partnershipId": {
      "filePath": "_app/_auth/partnerships/$partnershipId",
      "parent": "/_app/_auth",
      "children": [
        "/_app/_auth/partnerships/$partnershipId/_layout",
        "/_app/_auth/partnerships/$partnershipId/"
      ]
    },
    "/_app/_auth/partnerships/$partnershipId/_layout": {
      "filePath": "_app/_auth/partnerships/$partnershipId/_layout.tsx",
      "parent": "/_app/_auth/partnerships/$partnershipId"
    },
    "/_app/_auth/creators/$creatorId/": {
      "filePath": "_app/_auth/creators/$creatorId/index.tsx",
      "parent": "/_app/_auth/creators/$creatorId"
    },
    "/_app/_auth/dashboard/_layout/": {
      "filePath": "_app/_auth/dashboard/_layout.index.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/partnerships/$partnershipId/": {
      "filePath": "_app/_auth/partnerships/$partnershipId/index.tsx",
      "parent": "/_app/_auth/partnerships/$partnershipId"
    },
    "/_app/_auth/dashboard/_layout/partnerships/apply": {
      "filePath": "_app/_auth/dashboard/_layout.partnerships.apply.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/settings/affiliates": {
      "filePath": "_app/_auth/dashboard/_layout.settings.affiliates.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    },
    "/_app/_auth/dashboard/_layout/settings/billing": {
      "filePath": "_app/_auth/dashboard/_layout.settings.billing.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    },
    "/_app/_auth/dashboard/_layout/settings/creator-invites": {
      "filePath": "_app/_auth/dashboard/_layout.settings.creator-invites.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    },
    "/_app/_auth/dashboard/_layout/settings/invites": {
      "filePath": "_app/_auth/dashboard/_layout.settings.invites.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    },
    "/_app/_auth/dashboard/_layout/settings/team": {
      "filePath": "_app/_auth/dashboard/_layout.settings.team.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    },
    "/_app/_auth/dashboard/_layout/partnerships/": {
      "filePath": "_app/_auth/dashboard/_layout.partnerships.index.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/settings/": {
      "filePath": "_app/_auth/dashboard/_layout.settings.index.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    }
  }
}
ROUTE_MANIFEST_END */
